import React, { useState, useRef, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { themeQuartz } from "ag-grid-community";
import "./Grid.css";
import { gridOptions } from "./gridConfig";
import ActionButtonsRenderer from "./ActionButtonsRenderer";
import toast from 'react-hot-toast';
 import Data from "../mocks/LandUse.json";

// Register all community modules
ModuleRegistry.registerModules([AllCommunityModule]);

const LandUseGrid = () => {
  const gridApiRef = useRef(null);

  const apiEndpoint =
    "http://localhost:5275/crossing-cost";

  // Uncomment when using  JSON Mocks
  const [rowData] = useState(Data);
  // const [rowData, setRowData] = useState([]);

  const [pinnedRowData, setPinnedRowData] = useState([
    {
      diameter: "",
      crossing: "",
      cost: "",
    },
  ]);

  const [columnDefs] = useState([
    { field: "diameter" },
    { field: "landuse" },
    { field: "cost" },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: ActionButtonsRenderer,
      cellRendererParams: {
        url: apiEndpoint,
      },
      width: 100,
      sortable: false,
      filter: false,
      editable: false,
    },
    // ID
  ]);

  useEffect(() => {
    // API endpoint
    fetch(apiEndpoint+'s')
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => setRowData(data))
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const onCellEditingStopped = (params) => {
    const updatedData = params.data;
    // Handle creation of new row from pinned top row
    if (params.rowPinned === "top") {
      // Only trigger creation when exiting the last column
      const lastColumnField = "cost";
      if (params.column.getColId() !== lastColumnField) return;
      // if (params.colDef.field !== lastColumnField) return;

      const requiredFields = [
        "diameter",
        "crossing",
        "cost",
      ];

      const allFieldsFilled = requiredFields.every(
        (field) =>
          updatedData[field] && updatedData[field].toString().trim() !== ""
      );

      if (!allFieldsFilled) {
        // Silently skip creation if any field is missing
        return;
      }
      // Check for duplicate combination
      const isDuplicate = rowData.some(
        (row) =>
          row.crossing === updatedData.crossing &&
          row.diameter === updatedData.diameter &&
          row.cost === updatedData.cost
      );

      if (isDuplicate) {
        toast.error('Duplicate combination detected. Row not created.');
        console.warn("Duplicate combination detected. Row not created.");
        return;
      }

      // Proceed with creation
      fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Failed to create new row");
          return response.json();
        })
        .then((createdRow) => {
          setRowData((prev) => [...prev, createdRow]);

          // Flash the newly added row
          setTimeout(() => {
            const api = gridApiRef.current?.api ?? gridApiRef.current;
            if (!api) return;
                        
            let flashed = false;
            api.forEachNodeAfterFilterAndSort((node) => {
              if (!flashed && node.data.Id === createdRow.Id) {
                const rowElement = document.querySelector(
                  `.ag-center-cols-container .ag-row[row-index="${node.rowIndex}"]`
                );
                if (rowElement) {
                  rowElement.classList.add("row-flash");
                  setTimeout(
                    () => rowElement.classList.remove("row-flash"),
                    2000
                  );
                  flashed = true;
                }
              }
            });
          }, 100);

          // Reset pinned row to blank
          setPinnedRowData([
            {
              crossing: "",
              diameter: "",
              cost: "",
            },
          ]);
        })
        .catch((error) => {
          console.error("Create error:", error);
        });

      return;
    }
  };
  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    if (params.rowPinned === "top") {
      return;
    }
    console.log("Edited row:", updatedData);

    //  Send updated data to backend API
    fetch(`${apiEndpoint}/${updatedData.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to update");
        return response;
      })
      .then((data) => {
        console.log("Update successful:", data);
      })
      .catch((error) => {
        console.error("Update error:", error);
      });
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api;

    const allColumnIds = params.api.getColumns().map((col) => col.getColId());
    params.api.autoSizeColumns(allColumnIds);

    // Optional: then fit to grid width
    params.api.sizeColumnsToFit();
  };

  const defaultColDef = {
    editable: true,
    sortable: true,
    filter: true,
    resizable: true,
  };

  return (
    // height: "calc(100vh - 100px)"
    // className="ag-theme-alpine"
    <div className="boom-grid" style={{ height: 400, width: "100%" }}>
      <AgGridReact
        pagination={true}
        paginationPageSize={20}
        domLayout="autoHeight"
        gridOptions={gridOptions}
        rowData={rowData}
        columnDefs={columnDefs}
        animateRows={true}
        onGridReady={onGridReady}
        onCellValueChanged={onCellValueChanged}
        onCellEditingStopped={onCellEditingStopped}
        defaultColDef={defaultColDef}
        pinnedTopRowData={pinnedRowData}
      />
    </div>
  );
};

export default LandUseGrid;
